import type { IAccountant } from './accountant.types';

enum AccountantWorkspaceMemberRoleEnum {
  OWNER = 'owner', // exactly ONE per workspace
  ADMIN = 'admin',
  MEMBER = 'member',
}
export type AuthenticationDataType = {
  access_token: string;
  refresh_token_expires_at: string;
  refresh_token: string;
  iat: number;
  exp: number;
  sub: string;
  token_type: string;
  access?: {
    id: string;
    email: string;
    role: 'user' | 'admin' | 'accountant';
  };
};
export interface IAuthAccountant {
  access_token: string;
  refresh_token_expires_at: string;
  refresh_token: string;
  clientId: string;
  exp: number;
  sub: string;
  iss: string;
  iat: number;
  aud: string;
  token_type: string;
  accountant_email: string;
  workspace_id: string;
  workspace_role: AccountantWorkspaceMemberRoleEnum;
  role: 'user' | 'admin' | 'accountant';
}
export type AccountantAuthenticationDataType = {
  accountant: IAccountant;
  auth: IAuthAccountant;
};

export type IAuthResponse = {
  refresh_token: string;
  access_token: string;
  token_type: 'Bearer';
  iss: string;
  iat: number;
  exp: number;
  aud: string;
  sub: string;
  role: string;
};

/** Router state key for expert MFA flow (use with useCutRouterState). */
export const EXPERT_MFA_STATE_KEY = 'expertMfaState';

/** State passed to expert MFA flows (TOTP / recovery code) from login */
export type ExpertMfaState = {
  email?: string;
  password?: string;
  googleIdToken?: string;
  microsoftIdToken?: string;
  token?: string;
  invitation_token?: string;
} | null;

export type IAPILoginBody = {
  email: string;
  password: string;
  totpCode?: string;
  recoveryCode?: string;
  clientId?: string;
  authContinuation?: boolean;
  googleIdToken?: string;
  appleIdToken?: string;
  invitation_token?: string;
};

export type IAPIRefreshAccessTokenResponse = {
  access_token: string;
  token_type: string;
  cloudFrontCookies: {
    'CloudFront-Policy': string;
    'CloudFront-Key-Pair-Id': string;
    'CloudFront-Signature': string;
  };
  finalPayload: {
    aud: string;
    exp: number;
    iat: number;
    iss: string;
    role: string;
    sub: string;
  };
};

export type IAPIChangePasswordResponse = {
  ok: boolean;
  message: string;
};
